module.exports = __webpack_public_path__ + "img/ic-minus-black.c3e38532.svg";